(function () {
  'use strict';

  function apply() {
    var tpl = document.getElementById('mb-policy-en-body');
    if (!tpl) return;
    var target =
      document.querySelector('.shopify-policy__body .rte') ||
      document.querySelector('.shopify-policy__body');
    if (!target) return;
    target.innerHTML = tpl.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
